import styled from 'styled-components';
import { unitizedPx } from '@badi/badi-components';

export const ChatInputRoot = styled.div`
  padding: 0 0 ${unitizedPx(4)};
`;
